import { useParams, RouteProps, Navigate } from 'react-router-dom';

import { IntakeStatus } from 'types';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';

interface IIntakeRoute {
  redirect?: string;
  from?: string;
}

type TProps = RouteProps;

export default function IntakeRoute(props: TProps & IIntakeRoute) {
  const { offers, activeOffer } = useSelector((state: ApplicationState) => state.offers);
  const { intakeId, offerId } = useParams();
  const { redirect: redirectProp, from, element } = props;

  /*
    When to redirect a student for intake / offer urls:
      1. If a students offers have not loaded then stay on the current page for now
      2. If the student has no intakes then redirect to the "no active intakes" page
      3. If the student has all the intakes closed, then redirect to the "no active intakes" page
      4. If the url is not for an active offer[*] for the uni show the "inactive intake" page
      5. If the url is not the students active offer[*] then show the "intake select" page

    [*] Currently for this intake route an active intake / offer means any
        offer that does not have the status FUTURE. This will be updated once
        we deal with Closed and Archived intakes better.

    */

  let redirectTo = redirectProp;
  if (offers !== undefined) {
    const allOffersClosed = offers.every(offer => offer.intakeStatus === IntakeStatus.CLOSED);
    if (offers.length === 0 || allOffersClosed) {
      redirectTo = `/no-active-intake`;
    } else if (activeOffer) {
      if (activeOffer.intakeStatus === IntakeStatus.FUTURE) {
        redirectTo = '/inactive-intake';
      } else if (activeOffer && intakeId && offerId) {
        if (activeOffer.intakeId !== intakeId || activeOffer.offerId !== offerId) {
          redirectTo = '/intake-select';
        }
      }
    } else {
      redirectTo = '/intake-select';
    }
  }

  if (redirectTo) {
    return <Navigate to={redirectTo} state={{ from }} />;
  }

  return <> {element}</>;
}
